import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Redirect, Switch } from 'react-router-dom'
import { ContentRoute } from '../_metronic/layout'
import { ROLES } from '../utils/constants'
import CustomersPage from './modules/ContentManager/customers/CustomersPage'
import EditCustomersPage from './modules/ContentManager/customers/EditCustomersPage'
import EditOffersPage from './modules/ContentManager/offers/EditOffersPage'
import OffersPage from './modules/ContentManager/offers/OffersPage'
import OfferImportsPage from './modules/ContentManager/offers/OfferImportsPage'
import OfferImportDetailPage from './modules/ContentManager/offers/OfferImportDetailPage'
import EditObrasPage from './modules/ContentManager/obras/EditObrasPage'
import ObrasPage from './modules/ContentManager/obras/ObrasPage'
import EditPartidasCategoriesPage from './modules/ContentManager/partidaCategories/EditPartidasCategoriesPage'
import PartidasCategoriesPage from './modules/ContentManager/partidaCategories/PartidasCategoriesPage'
import EditPartidasPage from './modules/ContentManager/partidas/EditPartidasPage'
import PartidasPage from './modules/ContentManager/partidas/PartidasPage'
import EditProductFamiliesPage from './modules/ContentManager/productFamilies/EditProductFamiliesPage'
import ProductFamiliesPage from './modules/ContentManager/productFamilies/ProductFamiliesPage'
import EditProductsPage from './modules/ContentManager/products/EditProductsPage'
import ProductsPage from './modules/ContentManager/products/ProductsPage'
import EditProductUnitTypesPage from './modules/ContentManager/productUnitTypes/EditProductUnitTypesPage'
import ProductUnitTypesPage from './modules/ContentManager/productUnitTypes/ProductUnitTypesPage'
import MaterialGroupsPage from './modules/ContentManager/materialGroups/MaterialGroupsPage'
import EditSuppliersPage from './modules/ContentManager/suppliers/EditSuppliersPage'
import SuppliersPage from './modules/ContentManager/suppliers/SuppliersPage'
import EditSupplierTypesPage from './modules/ContentManager/supplierTypes/EditSupplierTypesPage'
import SupplierTypesPage from './modules/ContentManager/supplierTypes/SupplierTypesPage'
import EditUsersPage from './modules/ContentManager/users/EditUsersPage'
import UsersPage from './modules/ContentManager/users/UsersPage'
import { DashboardPage } from './pages/DashboardPage'
import EditProductMarcaPage from './modules/ContentManager/productMarca/EditProductMarcaPage'
import ProductMarcaPage from './modules/ContentManager/productMarca/ProductMarcaPage'
import OperariosPage from './modules/ContentManager/operarios/OperariosPage'
import OperarioCategoriesPage from './modules/ContentManager/operarioCategories/OperarioCategoriesPage'
import MailPage from './modules/ContentManager/configuration/MailPage'
import OpenAIConfigPage from './modules/ContentManager/configuration/OpenAIConfigPage'
import GeneralConfigPage from './modules/ContentManager/configuration/GeneralConfigPage'
import MessagingPage from './modules/ContentManager/configuration/MessagingPage'

export default function BasePage() {
	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	)

	const adminAccess =
    loggedUser?.role?.rango === ROLES.SUPER_ADMIN ||
    loggedUser?.role?.rango === ROLES.ADMIN
	const offerManagerAccess =
		loggedUser?.role?.rango === ROLES.GESTOR_OFERTAS

	return (
		<Switch>
			{/* Redirect from root URL to /dashboard. */}
			<Redirect exact from="/" to={offerManagerAccess ? "/ofertas" : "/dashboard"} />
			<ContentRoute
				path="/dashboard"
				component={offerManagerAccess ? OffersPage : DashboardPage}
			/>

			{/* COMERCIAL */}
			{/* Clientes */}
			<ContentRoute from="/clientes/:id?/edit" component={offerManagerAccess ? OffersPage : EditCustomersPage} />
			<ContentRoute from="/clientes" component={offerManagerAccess ? OffersPage : CustomersPage} />

			{/* Proveedores */}
			<ContentRoute
				from="/proveedores/:id?/edit"
				component={offerManagerAccess ? OffersPage : EditSuppliersPage}
			/>
			<ContentRoute from="/proveedores" component={offerManagerAccess ? OffersPage : SuppliersPage} />

			{/* Ofertas */}
			<ContentRoute
				from="/ofertas/:id?/:revisionNumber?/edit"
				component={EditOffersPage}
			/>
			<ContentRoute from="/ofertas/importaciones/:id" component={OfferImportDetailPage} />
			<ContentRoute from="/ofertas/importaciones" component={OfferImportsPage} />
			<ContentRoute from="/ofertas" component={OffersPage} />

			{/* Obras */}
			<ContentRoute
				from="/obras/:id?/edit"
				component={offerManagerAccess ? OffersPage : EditObrasPage}
			/>
			<ContentRoute from="/obras" component={offerManagerAccess ? OffersPage : ObrasPage} />

			{/* AMINISTRACION */}
			{/* Usuarios */}
			<ContentRoute
				from="/usuarios/:id?/edit"
				component={adminAccess ? EditUsersPage : DashboardPage}
			/>
			<ContentRoute
				from="/usuarios"
				component={adminAccess ? UsersPage : DashboardPage}
			/>

			{/* Operarios */}
			<ContentRoute
				from="/operarios"
				component={adminAccess ? OperariosPage : DashboardPage}
			/>
			<ContentRoute
				from="/categorias-operarios"
				component={adminAccess ? OperarioCategoriesPage : DashboardPage}
			/>

			{/* Configuración */}			
			<ContentRoute
				from="/configuracion/general"
				component={adminAccess ? GeneralConfigPage : DashboardPage}
			/>
			<ContentRoute
				from="/configuracion/ia"
				component={adminAccess ? OpenAIConfigPage : DashboardPage}
			/>
			<Redirect from="/configuracion/test-mail" to="/configuracion/mail?tab=historial" />
			<ContentRoute
				from="/configuracion/mail"
				component={adminAccess ? MailPage : DashboardPage}
			/>
			<ContentRoute
				from="/configuracion/mensajeria"
				component={adminAccess ? MessagingPage : DashboardPage}
			/>

			{/* Categorias de partidas */}
			<ContentRoute
				from="/categorias-partidas/:id?/edit"
				component={adminAccess || offerManagerAccess ? EditPartidasCategoriesPage : DashboardPage}
			/>
			<ContentRoute
				from="/categorias-partidas"
				component={adminAccess || offerManagerAccess ? PartidasCategoriesPage : DashboardPage}
			/>

			{/* Productos */}
			<ContentRoute
				from="/productos/:id?/edit"
				component={adminAccess || offerManagerAccess ? EditProductsPage : DashboardPage}
			/>
			<ContentRoute
				from="/productos"
				component={adminAccess || offerManagerAccess ? ProductsPage : DashboardPage}
			/>

			{/* Familias de productos */}
			<ContentRoute
				from="/familias-productos/:id?/edit"
				component={adminAccess || offerManagerAccess ? EditProductFamiliesPage : DashboardPage}
			/>
			<ContentRoute
				from="/familias-productos"
				component={adminAccess || offerManagerAccess ? ProductFamiliesPage : DashboardPage}
			/>

			{/* Tipos de unidades de productos */}
			<ContentRoute
				from="/tipos-unidades-productos/:id?/edit"
				component={adminAccess ? EditProductUnitTypesPage : DashboardPage}
			/>
			<ContentRoute
				from="/tipos-unidades-productos"
				component={adminAccess ? ProductUnitTypesPage : DashboardPage}
			/>

			<ContentRoute
				from="/agrupaciones-materiales"
				component={adminAccess || offerManagerAccess ? MaterialGroupsPage : DashboardPage}
			/>

			{/* Marcas de productos */}
			<ContentRoute
				from="/marcas-productos/:id?/edit"
				component={adminAccess || offerManagerAccess ? EditProductMarcaPage : DashboardPage}
			/>
			<ContentRoute
				from="/marcas-productos"
				component={adminAccess || offerManagerAccess ? ProductMarcaPage : DashboardPage}
			/>

			{/* Productos */}
			<ContentRoute
				from="/partidas/:id?/edit"
				component={adminAccess || offerManagerAccess ? EditPartidasPage : DashboardPage}
			/>
			<ContentRoute
				from="/partidas"
				component={adminAccess || offerManagerAccess ? PartidasPage : DashboardPage}
			/>

			{/* Tipos de proveedores */}
			<ContentRoute
				from="/tipos-proveedores/:id?/edit"
				component={adminAccess ? EditSupplierTypesPage : DashboardPage}
			/>
			<ContentRoute
				from="/tipos-proveedores"
				component={adminAccess ? SupplierTypesPage : DashboardPage}
			/>

			<Redirect to="/error" />
		</Switch>
	)
}
